import type { ReactElement } from 'react';

import { ModelBlockSessionsCard } from '../dashboard/ModelBlockSessionsCard.js';
import { ModelScheduleCard } from '../dashboard/ModelScheduleCard.js';
import { SettingsStack } from './SettingsStack.js';

export function SettingsSchedulePage(): ReactElement {
  return (
    <SettingsStack titleKey="common.studio.settings.scheduleTitle" hintKey="common.studio.settings.scheduleHint">
      <ModelScheduleCard />
      <ModelBlockSessionsCard />
    </SettingsStack>
  );
}
